import { languages } from '@app/constants/localization';

export const getAlphaLangCode = (state) => {
  switch (state.intl.locale) {
    case languages.AR:
      return 'ara';
    case languages.EN:
      return 'eng';
    default:
      return 'ara';
  }
};
